$(function () {
    $('form.search').submit(function (event) {
        var $query = $('form.search [name="query"]').val();
        captcha_search($query, 1);
        return false;
    });
    $(document).on("click", 'nav.pagination li a', function (event) {
        var $query = $('form.search [name="query"]').val();
        var $page = this.dataset.page;
        captcha_search($query, $page);
        return false;
    });

    function captcha_search($query, $page) {
        $('body').css('cursor', 'wait');
        $('.main-block').addClass('loaded');

        if (appConfig.isUseRecaptcha == '1') {
            grecaptcha.ready(function () {
                grecaptcha.execute(appConfig.recaptchaKey, { action: 'blog_search' }).then(function (token) {
                    search(token);
                });
            });
        } else {
            search();
        }

        function search(token) {
            scrollToTop();

            $.ajax({
                url: Routing.generate('blog_search'),
                type: 'json',
                method: 'GET',
                data: {
                    query: $query,
                    page: $page,
                    recaptchaResponse: token
                },
                success: function (response) {
                    if (response.error) {
                        switch (response.message) {
                            case '429':
                                $('#blog_page .main-block').html('<h2>Search servers are busy. Please try again in a minute.</h2>');
                                break;
                            case 'recaptcha':
                                $('#blog_page .main-block').html('<h2>Suspicious activity detected. Please try again later.</h2>');
                                break;
                            default:
                                $('#blog_page .main-block').html('<h2>Some error has happened. Please try again later.</h2>');
                        }
                    } else {
                        $('#blog_page .main-block').html(response);
                    }
                },
                complete: function() {
                    $('body').css('cursor', 'default');
                    $('.main-block').removeClass('loaded');
                }
            });
        }
    }

    function scrollToTop() {
        if (!$('.search-main-block').length) {
            return;
        }

        var top = $('#blog_page').offset().top - 110;
        $('html,body').animate({ scrollTop: top }, 500);
    }
});